<template>
  <div>
    <carousel
      :user="user"
      :token="token"
    />
    <div class="column is-12 no-padding">
      <div class="tabs is-toggle is-fullwidth">
        <ul>
          <tab
            v-for="tab in tabs"
            :key="tab.id"
            :tab-title="tab"
            :active-tab="activeTab"
            @switchActiveTab="switchActiveTab"
          />
        </ul>
      </div>
    </div>
    <transition
      v-if="show"
      name="component-fade"
      mode="out-in"
    >
      <component
        :is="customComponent || activeTab"
        v-bind="customProps"
        :user="user"
        :token="token"
        :region="region"
        :region-list="regionList"
        @message="message"
      />
    </transition>
  </div>
</template>

<script>
  import Carousel from '../carousel/Carousel.vue'
  import News from './NewsBlock.vue'
  import Tab from './Tab.vue'
  import Today from '../calendar/Main.vue'
//  import AhlToday from '../calendar/Main.vue'
  import HireAhlPoker from './SpecialEvents.vue'
  import RecentWinners from './ResentWinners.vue'
  import Races from '../standing/Races.vue'
  export default {
    name: 'Content',
    metaInfo: {
      title: 'AHL Poker :: Home'
    },
    components: {
      Carousel,
      News,
      Tab,
      Today,
      HireAhlPoker,
      RecentWinners,
      Races
    },
    props: ['user', 'token', 'region', 'regionList'],
    data () {
      return {
        customProps: {},
        customComponent: null,
        tabs: [
          'today',
          'all stars',
          'news',
          'recent winners',
        ],
        activeTab: '',
        mobileTabs: false,
        show: true
      }
    },
    computed: {
    },
    mounted () {
      this.switchTab()
    },
    methods: {
      switchActiveTab (tabTitle) {
        if (tabTitle === 'today') {
          this.$router.push({path: '/'})
        } else this.$router.push({path: tabTitle})
        this.switchTab()
      },
      switchTab () {
        this.customComponent = null;
        this.customProps = {};
        if (this.$route.path === '/news') {
          this.activeTab = 'news'
        } else if (this.$route.path === '/today') {
          this.activeTab = 'today'
        } else if (this.$route.path === '/recent-winners') {
          this.activeTab = 'recent-winners'
        } else if (this.$route.path === '/all-stars') {
          this.activeTab = 'all-stars'
          this.customComponent = 'Races';
          this.customProps = {filter: 'AllStars'}
        } else this.activeTab = this.tabs[0]
        this.mobileTabs = !this.mobileTabs
      },
      message (message) {
        message.showDialog = true;
        this.$emit('message', message)
      }
    }
  }
</script>

<style>
    .component-fade-enter-active, .component-fade-leave-active {
        transition: opacity .3s ease;
    }
    .component-fade-enter, .component-fade-leave-to
        /* .component-fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }
</style>